// project import
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import ScrollTop from 'components/ScrollTop';
import { useTranslation } from 'react-i18next';
import Routes from 'routes';
import ThemeCustomization from 'themes';
import { Whitelabelling } from 'layout/Whitelabelling';
import CookieConsent from 'react-cookie-consent';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App: React.FC = (): JSX.Element => {
    const { i18n } = useTranslation();
    return (
        <Whitelabelling>
            <ThemeCustomization>
                <LocalizationProvider dateAdapter={AdapterMoment} locale={i18n.language}>
                    <ScrollTop>
                        <Routes />
                        <CookieConsent
                            location="bottom"
                            buttonText="Ho capito"
                            cookieName="cookie-consent"
                            style={{ background: '#2B373B' }}
                            buttonStyle={{ color: '#4e503b', fontSize: '13px' }}
                            expires={150} // Numero di giorni prima che il cookie scada
                            onAccept={() => {
                                // Puoi aggiungere qui la logica per attivare cookie analitici o di marketing
                                console.log('Cookie accettati!');
                            }}
                            onDecline={() => {
                                // Puoi aggiungere qui la logica per disabilitare cookie non essenziali
                                console.log('Cookie rifiutati!');
                            }}
                        >
                            I cookie ci aiutano a fornire i nostri servizi. Utilizzando tali servizi, accetti l'utilizzo dei cookie da parte
                            nostra.{' '}
                            <span style={{ fontSize: '10px' }}>
                                Maggiori informazioni sulla nostra{' '}
                                <a href="https://www.beevoip.it/politica-utilizzo-cookies.php">Privacy Policy</a>
                            </span>
                        </CookieConsent>
                    </ScrollTop>
                </LocalizationProvider>
            </ThemeCustomization>
        </Whitelabelling>
    );
};

export default App;
